import { motion } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { scrollTo } from "@/components/Navbar";

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-[#222736]">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="flex justify-center pt-16"
      >
        <img
          src="/logo.png"
          alt="Merchant Alliance Brokerage — Your Cargo, Our Mission"
          className="w-72 max-w-full sm:w-96"
        />
      </motion.div>

      <div className="mx-auto mt-12 flex w-full max-w-7xl flex-col items-center justify-between gap-6 border-t border-[#222736] px-6 py-10 lg:flex-row lg:px-10">
        <p data-testid="footer-copyright" className="font-mono text-[10px] tracking-[0.2em] text-slate-500">
          © 2026 MERCHANT ALLIANCE BROKERAGE
        </p>
        <p className="font-mono text-[10px] tracking-[0.2em] text-slate-500">
          MC #71370379 · USDOT #8954053 · BONDED & INSURED
        </p>
        <div className="flex items-center gap-6">
          <a
            data-testid="footer-privacy-link"
            href="#hero"
            onClick={(e) => e.preventDefault()}
            className="font-mono text-[10px] tracking-[0.2em] text-slate-500 transition-colors hover:text-white"
          >
            PRIVACY
          </a>
          <a
            data-testid="footer-terms-link"
            href="#hero"
            onClick={(e) => e.preventDefault()}
            className="font-mono text-[10px] tracking-[0.2em] text-slate-500 transition-colors hover:text-white"
          >
            TERMS
          </a>
          <button
            data-testid="footer-back-to-top"
            onClick={() => scrollTo("#hero")}
            aria-label="Back to top"
            className="flex h-11 w-11 items-center justify-center border border-[#383F56] text-slate-400 transition-colors duration-300 hover:border-[#FF5500] hover:bg-[#FF5500] hover:text-white"
          >
            <ArrowUp className="h-4 w-4" />
          </button>
        </div>
      </div>
    </footer>
  );
}
